<template>
  <b-card title="Megrendelő szerkesztése">
    <b-row>
      <b-col md="6">
        <b-form-group
          label="Cégnév"
          label-for="company_name"
        >
          <b-form-input
            id="company_name"
            v-model="company_name"
            placeholder="Cégnév"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          label="Telefonszám"
          label-for="phone"
        >
          <b-form-input
            id="phone"
            v-model="phone"
            placeholder="Telefonszám"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          label="Kapcsolattartó neve"
          label-for="contact_name"
        >
          <b-form-input
            id="contact_name"
            v-model="contact_name"
            placeholder="Kapcsolattartó neve"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Céges logó -->
    <hr>
    <h5>Céges logó</h5>
    <small class="text-muted d-block mb-1">Az ajánlatok borítóján megjelenő logó (JPG, PNG, max 4 MB)</small>

    <div
      v-if="logo_url"
      class="mb-2"
    >
      <img
        :src="logo_url"
        alt="Céges logó"
        style="max-height: 80px; max-width: 300px; object-fit: contain; border: 1px solid #ddd; border-radius: 4px; padding: 6px; background: #fff;"
      >
      <br>
      <b-button
        variant="outline-danger"
        size="sm"
        class="mt-1"
        @click="deleteLogo"
      >
        <feather-icon
          icon="TrashIcon"
          size="14"
          class="mr-50"
        />
        Logó törlése
      </b-button>
    </div>
    <div
      v-else
      class="text-muted mb-1"
    >
      <feather-icon
        icon="ImageIcon"
        size="16"
        class="mr-50"
      />
      Nincs feltöltött logó
    </div>

    <b-form-file
      v-model="logo_file"
      accept="image/*"
      placeholder="Válassz képfájlt..."
      browse-text="Tallóz"
      class="mb-1"
      style="max-width: 400px;"
    />
    <br>
    <b-button
      variant="primary"
      size="sm"
      :disabled="!logo_file || logo_uploading"
      class="mb-2"
      @click="uploadLogo"
    >
      <feather-icon
        icon="UploadIcon"
        size="14"
        class="mr-50"
      />
      {{ logo_uploading ? 'Feltöltés...' : 'Logó feltöltése' }}
    </b-button>

    <hr>
    <b-button
      variant="primary"
      @click="save"
    >
      Mentés
    </b-button>
    <b-button
      variant="outline-secondary"
      class="ml-1"
      @click="$router.push('/client/list')"
    >
      Vissza
    </b-button>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BButton, BFormFile,
} from 'bootstrap-vue'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard, BRow, BCol, BFormGroup, BFormInput, BButton, BFormFile,
  },
  data() {
    return {
      company_name: '',
      phone: '',
      contact_name: '',
      logo_url: null,
      logo_file: null,
      logo_uploading: false,
    }
  },
  mounted() {
    this.loadClient()
  },
  methods: {
    loadClient() {
      axios({
        method: 'get',
        url: `client/${this.$route.params.id}`,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }).then(response => {
        this.company_name = response.data.company_name
        this.phone = response.data.phone
        this.contact_name = response.data.contact_name
        if (response.data.logo) {
          this.logo_url = `https://monolitcrm.hu/images/client_logos/${response.data.logo}`
        }
      })
    },
    save() {
      axios({
        method: 'put',
        url: `client/update/${this.$route.params.id}`,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        data: {
          company_name: this.company_name,
          phone: this.phone,
          contact_name: this.contact_name,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: { title: 'Sikeresen mentve', icon: 'CheckIcon', variant: 'success' },
        })
        this.$router.push('/client/list')
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: { title: 'Hiba történt', icon: 'XOctagonIcon', variant: 'danger' },
        })
      })
    },
    uploadLogo() {
      if (!this.logo_file) return
      this.logo_uploading = true
      const formData = new FormData()
      formData.append('logo', this.logo_file)
      axios({
        method: 'post',
        url: `client/${this.$route.params.id}/logo`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
      }).then(response => {
        this.logo_url = response.data.logo_url
        this.logo_file = null
        this.$toast({
          component: ToastificationContent,
          props: { title: 'Logó sikeresen feltöltve', icon: 'CheckIcon', variant: 'success' },
        })
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: { title: 'Hiba a logó feltöltése során', icon: 'XOctagonIcon', variant: 'danger' },
        })
      }).finally(() => {
        this.logo_uploading = false
      })
    },
    deleteLogo() {
      axios({
        method: 'delete',
        url: `client/${this.$route.params.id}/logo`,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }).then(() => {
        this.logo_url = null
        this.logo_file = null
        this.$toast({
          component: ToastificationContent,
          props: { title: 'Logó törölve', icon: 'TrashIcon', variant: 'success' },
        })
      })
    },
  },
}
</script>
